import { CSSProperties } from 'react';
import { Space } from 'tdesign-react';

import { Empty2 } from '@/components/icon';

import styles from './index.module.less';

interface IProps {
  text?: string,
  svgStyle?: CSSProperties,
  emptyIcon?: React.ReactNode
}
const Empty: React.FC<IProps> = ({ text, svgStyle, emptyIcon }) => (
  <Space direction="vertical" size="large" style={{ width: '100%' }}>
    <div className={styles.empty}>
      {emptyIcon ? emptyIcon : <Empty2 style={{ ...svgStyle }} />}
      <span className={styles.text} >{text ? text : ''}</span>
    </div>
  </Space>
);

export default Empty;
